import {
	type CalculateRiskInsuranceRequest,
	Configuration,
	RiskCalculatorApi,
} from "@bankmonitor/simple-calculators-rest-client";
import { Config } from "@/app/config";
import http from "@/shared/lib/http";
import type { FormFields, RiskInsuranceResponse, RiskInsuranceResponseMap } from "./types";

const mapRequest = (request: FormFields): CalculateRiskInsuranceRequest => {
	return {
		birthYear: request.birthYear,
		durationYears: request.durationYears,
		riskInsuranceAmount: request.riskInsuranceAmount,
		riskInsurance: request.mainInsuranceGoal === "RISK_INSURANCE",
		creditInsurance: request.mainInsuranceGoal === "CREDIT_INSURANCE",
		disability: request.additionalInsuranceGoal.includes("DISABILITY"),
		accidentProtection: request.additionalInsuranceGoal.includes("ACCIDENT_PROTECTION"),
		dreadDisease: request.additionalInsuranceGoal.includes("DREAD_DISEASE"),
	};
};

export async function calculate(request: FormFields): Promise<RiskInsuranceResponseMap> {
	const configuration = new Configuration({ basePath: Config.getApiUrl("/api/public/simple-calculator/v1") });
	const api = new RiskCalculatorApi(configuration);

	return api.calculateRiskInsurance({ calculateRiskInsuranceRequest: mapRequest(request) });
}

/**
 * @deprecated Use calculate instead
 */
export async function calculateOld(request: FormFields): Promise<RiskInsuranceResponseMap> {
	const response = await http.post(Config.getApiUrl("/api/public/risk/calculate"), mapRequest(request));

	return {
		MetLife: response,
	};
}

export const getCheapestOffer = (calculatorResponse: RiskInsuranceResponseMap): RiskInsuranceResponse | undefined => {
	return Object.values(calculatorResponse).reduce(
		(min, current) => (current.sumPrice < min.sumPrice ? current : min),
		Object.values(calculatorResponse)?.[0],
	);
};
